// 银行
export default {
  bankAccountList: {
    search: {
      company: '公司',
      companyPlaceholder: '请选择公司',
      bankNational: '银行国家',
      bankNationalPlaceholder: '请选择银行国家',
      bankName: '银行名称',
      bankNamePlaceholder: '请输入分行名称',
      bankCode: '银行代码',
      bankCodePlaceholder: '请输入银行代码',
      bankAccountName: '银行账户',
      bankAccountNamePlaceholder: '请输入银行账户',
      bankAccountDesc: '账户描述',
      bankAccountDescPlaceholder: '请输入账户描述',
      bankAccountNum: '银行账号',
      bankAccountNumPlaceholder: '请输入银行账号',
      classCode: '账户属性',
      classCodePlaceholder: '请选择账户属性',
      secondaryClassCode: '帐户二级属性',
      secondaryClassCodePlaceholder: '请选择帐户二级属性',
      generalLedgerAccount: '总账科目',
      generalLedgerAccountPlaceholder: '请选择总账科目',
      bankAccountStatus: '账户状态',
      bankAccountStatusPlaceholder: '请选择账户状态',
      gmtCreateStart: '创建日期从',
      gmtCreateStartPlaceholder: '请选择创建日期',
      gmtCreateEnd: '创建日期到',
      gmtCreateEndPlaceholder: '请选择创建日期',
    },
    table: {
      companyCode: '公司代码',
      companyName: '公司名称',
      bankCode: '银行代码',
      bankName: '银行名称',
      branchName: '分行',
      branchCode: '银行联行号',
      bankUnionNumber: '银行行号',
      bankConnectionFlag: '银企直连标识',
      bankAccountName: '银行账户',
      bankAccountDesc: '账户描述',
      bankAccountNum: '银行账户号码',
      classCode: '账户属性',
      secondaryClassCode: '帐户二级属性',
      currencyCode: '账户币别',
      generalLedgerAccount: '总账科目',
      createBy: '创建人',
      gmtCreate: '创建日期',
      lastModifiedBy: '最后修改人',
      gmtModified: '最后修改日期',
      bankAccountStatus: '账户状态',
      isDefault: '默认账户',
    },
    buttons: {
      forbid: '禁用',
      enable: '启用',
      import: '导入',
    },
    tips: {
      noSelected: '您还未选择任何数据!',
      noForbid: '失效状态不能编辑！',
      onlyOneSelectData: '请选择一条数据进行操作!',
      noExport: '当前没有数据可以导出！',
      cannotEnable: '所选数据中没有失效状态，请重新选择！',
      cannotForbid: '所选数据中没有有效状态，请重新选择！',
      hasCannotEnable: '所选数据中有不可启用的数据，点击确认只会启用失效状态的数据！',
      hasCannotForbid: '所选数据中有不可禁用的数据，点击确认只会禁用有效状态的数据！',
    },
  },
};
